export async function requestInterceptor(req) {
  req.headers = {
    ...req.headers,
    'Content-Type': 'application/json',
    'ocp-apim-subscription-key': process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY
  };
  return req;
}
